/* Payments (M5.2) — verbatim from mockup core.js. */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_PAYMENTS = SUPPLY_DATA.payments
